<template>
<div>
    <!-- modal -->
    <b-modal id="matterBudgetReportFormModal" ref="matterBudgetReportFormModal" centered size="xl" no-close-on-backdrop :title=" $t('lawMatterBudgetReport.info')" hide-footer>
        <b-row>
            <b-col>
                <div class="custom-search d-flex justify-content-end mb-1">
                    <b-button variant="outline-primary" size="sm" class="mr-1" @click.prevent="budgetExcel">
                        {{ $t('others.excel') }}
                    </b-button>
                </div>
            </b-col>
        </b-row>
        <b-card>
            <b-row>
                <b-col>
                    <label class="h5">{{ $t('lawMatterBudgetReport.attorney_fees') }}</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label class="text-danger">{{ $t('lawMatterBudgetReport.paid_attorney_fees') }}</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                    <law-matter-budget-report-billed-attorney-fee-list ref="lawMatterBudgetReportBilledAttorneyFeeTable" :lawMatterId="this.id"></law-matter-budget-report-billed-attorney-fee-list>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-8">
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="billed-attorney-fee-amount-input">{{ $t('lawMatterBudgetReport.paid_attorney_fee_total') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" id="billed-attorney-fee-amount-input" v-model="paidAttorneyFeeTotal" maxlength="50" disabled />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label class="text-danger">{{ $t('lawMatterBudgetReport.unpaid_attorney_fees') }}</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                    <law-matter-budget-report-non-billed-attorney-fee-list ref="lawMatterBudgetReportNonBilledAttorneyFeeTable"></law-matter-budget-report-non-billed-attorney-fee-list>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-8">
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="non-billed-attorney-fee-amount-input">{{ $t('lawMatterBudgetReport.unpaid_attorney_fee_total') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" id="non-billed-attorney-fee-amount-input" v-model="unpaidAttorneyFeeTotal" maxlength="50" disabled />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <!-- STOCK-2875 Faz 9: Arşivlenmiş Avukatlık Ücretleri -->
            <b-row>
                <b-col>
                    <label class="text-danger">{{ $t('lawMatterBudgetReport.archived_attorney_fees') }}</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                    <law-matter-budget-report-archived-attorney-fee-list ref="lawMatterBudgetReportArchivedAttorneyFeeTable" :reload="reloadAll"></law-matter-budget-report-archived-attorney-fee-list>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-8"></b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="archived-attorney-fee-amount-input">{{ $t('lawMatterBudgetReport.archived_attorney_fee_total') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" id="archived-attorney-fee-amount-input" v-model="archivedAttorneyFeeTotal" maxlength="50" disabled />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-8">
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="attorney-fee-amount-input">{{ $t('lawMatterBudgetReport.attorney_fee_total') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" id="attorney-fee-amount-input" v-model="totalAttorneyFee" maxlength="50" disabled />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
        </b-card>
        <b-card>
            <b-row>
                <b-col>
                    <label class="h5">{{ $t('lawMatterBudgetReport.expenses') }}</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label class="text-danger">{{ $t('lawMatterBudgetReport.paid_expenses') }}</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                    <law-matter-budget-report-billed-expenses-list ref="lawMatterBudgetReportBilledExpensesTable"></law-matter-budget-report-billed-expenses-list>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-8">
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="billed-expenses-amount-input">{{ $t('lawMatterBudgetReport.paid_expenses_total') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" id="billed-expenses-amount-input" v-model="paidExpensesTotal" maxlength="50" disabled />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label class="text-danger">{{ $t('lawMatterBudgetReport.unpaid_expenses') }}</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                    <law-matter-budget-report-non-billed-expenses-list ref="lawMatterBudgetReportNonBilledExpensesTable"></law-matter-budget-report-non-billed-expenses-list>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-8">
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="non-billed-expenses-amount-input">{{ $t('lawMatterBudgetReport.unpaid_expenses_total') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" id="non-billed-expenses-amount-input" v-model="unpaidExpensesTotal" maxlength="50" disabled />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <!-- STOCK-2875 Faz 9: Arşivlenmiş Masraflar -->
            <b-row>
                <b-col>
                    <label class="text-danger">{{ $t('lawMatterBudgetReport.archived_expenses') }}</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-12">
                    <law-matter-budget-report-archived-expenses-list ref="lawMatterBudgetReportArchivedExpensesTable" :reload="reloadAll"></law-matter-budget-report-archived-expenses-list>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-8"></b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="archived-expenses-amount-input">{{ $t('lawMatterBudgetReport.archived_expenses_total') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" id="archived-expenses-amount-input" v-model="archivedExpensesTotal" maxlength="50" disabled />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-8">
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label for="expenses-amount-input">{{ $t('lawMatterBudgetReport.expenses_total') }}</label>
                        <b-form-group>
                            <b-form-input size="sm" id="expenses-amount-input" v-model="totalExpenses" maxlength="50" disabled />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
        </b-card>

    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getMatterBudgetReportList: {
            type: Function
        },
        lawMatterId: {
            type: Number
        },
        // STOCK-2875 Faz 9: "Daily Work'e Taşı" sonrası MatterForm'daki Dailywork alt-tablosunu yeniler.
        dailyworkReload: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            paidAttorneyFeeList: [],
            unpaidAttorneyFeeList: [],
            paidExpensesList: [],
            unpaidExpensesList: [],
            paidAttorneyFeeTotal: 0,
            unpaidAttorneyFeeTotal: 0,
            totalAttorneyFee: 0,
            unpaidExpensesTotal: 0,
            paidExpensesTotal: 0,
            totalExpenses: 0,
            archivedAttorneyFeeTotal: 0,
            archivedExpensesTotal: 0
        }
    },
    methods: {
        // STOCK-2875 Faz 9: "Daily Work'e Taşı" sonrası hem bütçe raporunu hem Dailywork alt-tablosunu yenile.
        reloadAll() {
            this.showInfo()
            if (this.dailyworkReload) this.dailyworkReload()
        },
        showInfo() {
            this.$refs['matterBudgetReportFormModal'].show()
            const data = {
                lawMatterId: this.lawMatterId
            }
            const controller = {
                name: 'LawDailywork',
                actionName: 'GetLawDailyworkBudgetReportByLawMatterId'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    // STOCK-2875 Faz 9: reload-safe — callback'te modal render edilmiş, ref'ler mevcut.
                    // Tabloları sıfırla ki "Daily Work'e Taşı" sonrası tekrar çağrıldığında duplicate/eski kayıt kalmasın.
                    this.$refs.lawMatterBudgetReportBilledAttorneyFeeTable.rows = []
                    this.$refs.lawMatterBudgetReportNonBilledAttorneyFeeTable.rows = []
                    this.$refs.lawMatterBudgetReportArchivedAttorneyFeeTable.rows = []
                    this.$refs.lawMatterBudgetReportBilledExpensesTable.rows = []
                    this.$refs.lawMatterBudgetReportNonBilledExpensesTable.rows = []
                    this.$refs.lawMatterBudgetReportArchivedExpensesTable.rows = []
                    if (response.data.lawDailyworkBudgetReportAttorneyFeePaidList !== null && response.data.lawDailyworkBudgetReportAttorneyFeePaidList.length > 0) {
                        this.$refs.lawMatterBudgetReportBilledAttorneyFeeTable.setValues(response.data.lawDailyworkBudgetReportAttorneyFeePaidList)
                    }
                    if (response.data.lawDailyworkBudgetReportAttorneyFeeUnpaidList !== null && response.data.lawDailyworkBudgetReportAttorneyFeeUnpaidList.length > 0) {
                        this.$refs.lawMatterBudgetReportNonBilledAttorneyFeeTable.setValues(response.data.lawDailyworkBudgetReportAttorneyFeeUnpaidList)
                    }
                    if (response.data.lawDailyworkBudgetReportAttorneyFeeArchivedList !== null && response.data.lawDailyworkBudgetReportAttorneyFeeArchivedList.length > 0) {
                        this.$refs.lawMatterBudgetReportArchivedAttorneyFeeTable.setValues(response.data.lawDailyworkBudgetReportAttorneyFeeArchivedList)
                    }
                    if (response.data.lawDailyworkBudgetReportExpensesPaidList !== null && response.data.lawDailyworkBudgetReportExpensesPaidList.length > 0) {
                        this.$refs.lawMatterBudgetReportBilledExpensesTable.setValues(response.data.lawDailyworkBudgetReportExpensesPaidList)
                    }
                    if (response.data.lawDailyworkBudgetReportExpensesUnpaidList !== null && response.data.lawDailyworkBudgetReportExpensesUnpaidList.length > 0) {
                        this.$refs.lawMatterBudgetReportNonBilledExpensesTable.setValues(response.data.lawDailyworkBudgetReportExpensesUnpaidList)
                    }
                    if (response.data.lawDailyworkBudgetReportExpensesArchivedList !== null && response.data.lawDailyworkBudgetReportExpensesArchivedList.length > 0) {
                        this.$refs.lawMatterBudgetReportArchivedExpensesTable.setValues(response.data.lawDailyworkBudgetReportExpensesArchivedList)
                    }
                    this.paidAttorneyFeeTotal = this.$formatMoney(response.data.amountOfBilledAttorneyFee)
                    this.unpaidAttorneyFeeTotal = this.$formatMoney(response.data.amountOfNonBilledAttorneyFee)
                    this.archivedAttorneyFeeTotal = this.$formatMoney(response.data.amountOfArchivedAttorneyFee)
                    this.totalAttorneyFee = this.$formatMoney(response.data.totalAmountAttorneyFee)
                    this.totalExpenses = this.$formatMoney(response.data.totalAmountExpenses)
                    this.paidExpensesTotal = this.$formatMoney(response.data.amountOfBilledExpenses)
                    this.unpaidExpensesTotal = this.$formatMoney(response.data.amountOfNonBilledExpenses)
                    this.archivedExpensesTotal = this.$formatMoney(response.data.amountOfArchivedExpenses)

                } else {
                    this.$bvModal.hide('matterBudgetReportFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        budgetExcel() {
            const controller = {
                name: 'LawDailywork',
                actionName: 'CreateLawDailyworkBudgetReportExcel'
            }
            const data = {
                lawMatterId: this.lawMatterId
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile(response.data.fileName, response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
